import { useState } from 'react';
import { useMutation } from 'data-fetching-client';
import FormattedMessage from 'I18n/components/FormattedMessage';
import UIFormControl from 'UIComponents/form/UIFormControl';
import UITextArea from 'UIComponents/input/UITextArea';
import UILoadingButton from 'UIComponents/button/UILoadingButton';
import { getWebhookResponseBody } from 'automation-ui-log-events/records/LogEvent/contextMapUtils';
import { SEND_USER_INTERACTION } from 'automation-ui-canvas/containers/enrollment-history/panel/queries/userInteractionQueries';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export default function UserInputPrompt({
  logEvent,
  onSubmit
}) {
  const [userResponse, setUserResponse] = useState('');
  const [sendUserInteraction, {
    loading,
    error
  }] = useMutation(SEND_USER_INTERACTION);
  const webhookResponse = getWebhookResponseBody(logEvent);
  const {
    outputFields: {
      prompt,
      callbackId
    }
  } = JSON.parse(webhookResponse);
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(UIFormControl, {
      label: prompt,
      children: /*#__PURE__*/_jsx(UITextArea, {
        use: "on-dark",
        value: userResponse,
        onChange: ({
          target: {
            value
          }
        }) => setUserResponse(value)
      })
    }), /*#__PURE__*/_jsx(UILoadingButton, {
      className: "m-y-3",
      use: "primary",
      onClick: () => void sendUserInteraction({
        variables: {
          callbackId,
          userResponse
        }
      }).then(() => onSubmit()),
      loading: loading,
      failed: !!error,
      keepResultAfterFinish: !error,
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "automation.enrollmentHistory.panel.selected-enrollment.user-input.submitResponseButton"
      })
    })]
  });
}